import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import FieldContainer from "../FieldContainer";
import Money from "utils/Money";
import MoneyInput from "nlib/common/MoneyInput";
import React, { useCallback } from "react";
import useDocumentContext from "hooks/useDocumentContext";

const AmountField = (props) => {
  const id = "amount";

  const { uiTexts } = useSelector(getTextsData);

  const {
    documentState: { [id]: value, currency, amountBase, amountVat },
    documentData: { paidTransactions = [] },
    lineItemsTotalConsistent,
    setDocumentState
  } = useDocumentContext();

  const normalizedAmount = Money.toMoneyNumber((value || 0), true, "....");

  const normalizedAmountBase = Money.toMoneyNumber((amountBase || 0), true, "....");

  const normalizedAmountVat = Money.toMoneyNumber((amountVat || 0), true, "....");

  const normalizedPaidTransactionsAmount = paidTransactions.length
    ? Money.toMoneyNumber(paidTransactions.reduce((acc, transaction) => {
      return acc + transaction.amount;
    }, 0), true, "....")
    : 0;

  const invalid = normalizedAmount !== Money.toMoneyNumber(normalizedAmountBase + normalizedAmountVat, true, "....")
    || (!!paidTransactions.length && (normalizedAmount !== normalizedPaidTransactionsAmount))
    || !lineItemsTotalConsistent;

  const handleChange = useCallback((val) => {
    setDocumentState({ [id]: val });
  }, [setDocumentState]);

  return (
    <FieldContainer
      type="number"
      id={id}
      confidenceFields={["amount"]}
      label={uiTexts.total}
      invalid={invalid}
      value={value}
      placeholder={uiTexts.enterTotal}
      displayValue={Money.toMoneyString(value || 0, currency)}
      component={MoneyInput}
      currency={currency}
      onChange={handleChange}
      {...props} />
  );
};

export default React.memo(AmountField);
